// Register the Velvet service worker (Web Push only). Idempotent.
export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
    return reg;
  } catch (e) {
    console.warn('SW register failed', e);
    return null;
  }
}

// Convert VAPID pubkey (URL-safe base64) to Uint8Array required by PushManager.
function urlBase64ToUint8Array(b64) {
  const padding = '='.repeat((4 - b64.length % 4) % 4);
  const base64 = (b64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return typeof window !== 'undefined'
    && 'serviceWorker' in navigator
    && 'PushManager' in window
    && 'Notification' in window;
}

export function pwaInstalled() {
  // iOS Safari only fires Web Push in a PWA installed to the Home Screen.
  return typeof window !== 'undefined'
    && (window.matchMedia('(display-mode: standalone)').matches
        || window.navigator.standalone === true);
}

export async function enablePush(apiFetch) {
  if (!pushSupported()) throw new Error('Este navegador no soporta Web Push.');
  const reg = await registerServiceWorker();
  if (!reg) throw new Error('No se pudo registrar el service worker.');
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error(`Permiso denegado (${perm}).`);
  const { public_key } = await apiFetch('/whatsapp/push/vapid');
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(public_key),
  });
  await apiFetch('/whatsapp/push/subscribe', {
    method: 'POST',
    body: JSON.stringify({ subscription: sub.toJSON(), user_agent: navigator.userAgent }),
  });
  return true;
}

export async function disablePush(apiFetch) {
  const reg = await navigator.serviceWorker?.getRegistration('/');
  const sub = await reg?.pushManager.getSubscription();
  if (sub) {
    await apiFetch('/whatsapp/push/unsubscribe', { method: 'POST', body: JSON.stringify({ endpoint: sub.endpoint }) });
    try { await sub.unsubscribe(); } catch {}
  }
}

export async function pushCurrentlyEnabled() {
  if (!pushSupported()) return false;
  const reg = await navigator.serviceWorker?.getRegistration('/');
  const sub = await reg?.pushManager.getSubscription();
  return !!sub && Notification.permission === 'granted';
}
